export const lightGreen50 = "#ebf8e9";
export const lightGreen100 = "#e3f6d8";
export const lightGreen200 = "#c8eeb1";
export const lightGreen300 = "#ace68b";
export const lightGreen400 = "#91de64";
export const lightGreen500 = "#76d63e";
export const lightGreen600 = "#60cd32";
export const lightGreen700 = "#4ac526";
export const lightGreen800 = "#34bb1a";
export const lightGreen900 = "#1fb30f";
export const lightGreen1000 = "#0e9603";
export const lightGreenA100 = "#d4f66f";
export const lightGreenA200 = "#b1ea5d";
export const lightGreenA400 = "#3bc11f";
export const lightGreenA500 = "#09a004";
export const lightGreenA1000 = "#294a15";
